import "./topbar.scss"
type MenuType = {
    menuOpen : boolean;
    setMenuOpen(flag:boolean):void;
};
export default function Topbar({menuOpen, setMenuOpen}:MenuType) {
    return (
        <div className="topBar">
            <div className="topContent">
                <div className="topNav">
                    <div className="topNavMenu">
                        <ul>
                            <li><a href="#home">HOME</a></li>
                            <li><a href="#mynok">My NOK</a></li>
                            <li><a href="#gallery">Gallery</a></li>
                            <li><a href="#game">Game</a></li>
                        </ul>
                        <a href="https://opensea.io/collection/nok"><button className="topConnectButton">BUY</button></a>
                        <div className={(menuOpen ? "hamburger active" : "hamburger")} onClick = {()=> setMenuOpen(!menuOpen)}>
                            <span className="line1"></span>
                            <span className="line2"></span>
                            <span className="line3"></span>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>
    )
}
